import {
    FieldInCard,
} from 'app/types/form.types'
import {
    DaysOfWeek,
} from 'app/enums/label.enums'

import {
    OperationalHour,
} from '../../serviceCenters.types'

const getFields = (
    getAllowedValues: (param: Record<string, string>) => Record<string, string>,
    isOperational: boolean,
): FieldInCard<keyof OperationalHour>[] => {
    return [
        {
            id: 'column1',
            fields: [{
                name: 'isOperational',
                componentName: 'Switch',
                labelKey: ' ',
            }],
        },
        {
            id: 'column2',
            fields: [{
                name: 'dayOfWeek',
                componentName: 'EnumSelector',
                allowedValues: getAllowedValues(DaysOfWeek),
                disabled: true,
                labelKey: 'DAY_OF_THE_WEEK',
            }],
        },
        {
            id: 'column3',
            fields: [{
                name: 'workStartsAt',
                componentName: 'TimePicker',
                disabled: !isOperational,
                required: isOperational,
                labelKey: 'STARTS_AT',
            }],
        },
        {
            id: 'column4',
            fields: [{
                name: 'workEndsAt',
                componentName: 'TimePicker',
                disabled: !isOperational,
                required: isOperational,
                labelKey: 'ENDS_AT',
            }],
        },
    ]
}

export default getFields
